import React, { useState, useEffect } from 'react';
import { TitlePage } from 'components';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';
export function ModalAlert({ isActive, isClose, path }) {

  const [wantCancel, setWantCancel] = useState(isActive);

  useEffect(() => {
    setWantCancel(isActive);
  }, [isActive, wantCancel]);

  const closeModal = () => {
    setWantCancel(false);
    isClose(false);
  }

  const makeURL = (path) => {
    const address = window.location;
    return address.origin+"/whats/#/"+path;
  }

  const cancelSave = () => {
    window.location.href = makeURL(path);
  }

  return (
    <Modal isOpen={wantCancel}>
      <ModalBody>
        <TitlePage title="Deseja cancelar?" />
        <ModalFooter>
          <Button onClick={cancelSave} color="primary">
            Sim
          </Button>
          <Button onClick={closeModal} color="secundary">
            Não
          </Button>
        </ModalFooter>
      </ModalBody>
    </Modal>
  );
}
